module.exports = __webpack_public_path__ + "img/container_ui_second.915226c3.png";